import styled from 'styled-components';

export const ChildAccountReportingWrapper = styled.div`
 display: flex;
`;
